import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import { TypeAsserter } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

import * as common from '../../../../../common'

export const DOC = gql`
  ${common.gql.display.link.fragments.linkDestination.DOC}
  fragment FragmentBreadcrumb on Breadcrumb {
    name
    goto {
      ...FragmentLinkDestination
    }
  }
`

export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentBreadcrumbFragment,
  ents.core.display.Breadcrumb
>({
  goto: common.gql.display.link.fragments.linkDestination.TRANSFORMER,
  name: graphql.transformers.OUT.default(transformers.PASS_THROUGH, ''),
})
